import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TOOLS_PATH = /^\/tools(\/|$)/;

// /tools 下不展示广告。AdSense 脚本一旦加载就无法卸载,
// 所以从站内进入 /tools 时若脚本已存在,需整页刷新来清除它。
export const AdsenseGuard = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const loaded = !!document.getElementById('adsense-script');
    if (TOOLS_PATH.test(pathname)) {
      if (loaded) {
        window.location.reload();
      }
    } else if (!loaded && typeof window.__loadAdsense === 'function') {
      window.__loadAdsense();
    }
  }, [pathname]);

  return null;
};
